import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../provider/AuthContext";
import { jwtDecode } from "jwt-decode";

const Callback = () => {
  const navigate = useNavigate();
  const { setToken, setUser, setAllowedPhones, setHasFullAccess } = useAuth();

  const loadUserAccessInfo = async (token: string) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/user/profile`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        
        setAllowedPhones(data.access.allowedPhones || []);
        setHasFullAccess(data.access.hasFullAccess || false);
        
      } else {
        setAllowedPhones([]);
        setHasFullAccess(false);
      }
    } catch (error) {
      console.error('❌ Error loading user access info:', error);
      setAllowedPhones([]);
      setHasFullAccess(false);
    }
  };

  useEffect(() => {
    const handleAuth = async () => {
      const queryParameters = new URLSearchParams(window.location.search);
      const token = queryParameters.get("token");
      
      if (!token) {
        navigate(process.env.REACT_APP_AWS_START_URL || "");
        return;
      }

      try {
        const decoded: any = jwtDecode(token);

        const user = decoded.profile;

        if (user) {
          setToken(token);
          setUser(user);

          await loadUserAccessInfo(token);
          
          const getCookie = (name: string) => {
            const cookies = document.cookie.split(';');
            for (let cookie of cookies) {
              const [key, value] = cookie.trim().split('=');
              if (key === name) return value;
            }
            return null;
          };
          
          const targetPhone = getCookie('targetPhone');
          
          if (targetPhone) {
            navigate(`/phone/${targetPhone}`);
          } else {
            navigate("/");
          }
        } else {
          navigate(process.env.REACT_APP_AWS_START_URL!);
        }
      } catch (error) {
        navigate(process.env.REACT_APP_AWS_START_URL!);
      }
    };

    handleAuth();
  }, [navigate, setToken, setUser, setAllowedPhones, setHasFullAccess]);

  return null;
};

export default Callback;
